import { Component, React } from "react";
import user from "../icons/user.png"
export default class StartMenu extends Component {
    render() {
        return(
            <div className="StartMenu">
                <div className="UserGroup">
                    <img id="UserProfilePicture" src={user} alt="user"/>
                    <div id="UserName">Zachary Hill</div>
                        <div style={{ padding: "0 10px" }}>
            <h3>Welcome to my Portfolio!</h3>
            <p>Here is a quick guide on how to navigate this desktop environment:</p>
            
            <ul style={{ paddingLeft: "20px", lineHeight: "1.6" }}>
              <li>
                <strong>Desktop Icons:</strong> Double-click icons on the desktop (like "Projects" or "About Me") to open their respective windows.
              </li>
              <li>
                <strong>Taskbar:</strong> Use the taskbar at the bottom to switch between open windows.
              </li>
              <li>
                <strong>Projects:</strong> Inside the Projects window, click on any folder icon to view details about that specific project.
              </li>
              <li>
                <strong>Images:</strong> Click on any image within a project description to expand it into a full-size viewer.
              </li>
              <li>
                <strong>Resizing: Click and drag on the grey in bottom right corner of a window to resize.</strong>
              </li>
            </ul>
            
            <div style={{ marginTop: "20px", fontStyle: "italic", fontSize: "0.9em" }}>
              <p>Click the Start button to close this menu.</p>
              <p>Feel free to drag windows around and explore!</p>
            </div>
          </div>
                    </div>
                </div>
        )
    }
}